export const mailBody = encodeURIComponent(`
To add a CNAME record, access your domain provider’s DNS settings.
GoDaddy guide: https://www.godaddy.com/help/add-a-cname-record-19236
Namecheap guide: https://www.namecheap.com/support/knowledgebase/article.aspx/9564/2237/how-can-i-set-up-a-cname-record-for-my-domain/
    1.  Log in to your domain provider.
    2.  Go to DNS settings.
    3.  Add a CNAME record.
    4.  Enter the subdomain in “Hostname,” set type to “CNAME,” and use “savibook.com” as the value.
    5.  Save changes.`)
